// extracted by mini-css-extract-plugin
export var fixedPanel = "style-module--fixedPanel--bd146";
export var fixedPanelActive = "style-module--fixedPanelActive--67d24";
export var fixedPanelColumn = "style-module--fixedPanelColumn--94e58";
export var fixedPanelRow = "style-module--fixedPanelRow--12b2f";
export var fixedPanelSidebar = "style-module--fixedPanelSidebar--1dfa4";
export var hideOnFixed = "style-module--hideOnFixed--e668b";